export default "__VITE_ASSET__B70Nd968__"